const state = {
  config: {
    isPageLoading: false,
    isMenuCollapse: false,
  },
};

const mutations = {
  setPageLoading(state, isPageLoading) {
    state.config.isPageLoading = isPageLoading;
  },
  setMenuCollapse(state, data) {
    state.config.isMenuCollapse = data ? data : !state.config.isMenuCollapse;
  },
};

const getters = {
  isPageLoading() {
    return state.config.isPageLoading;
  },
  isMenuCollapse() {
    return state.config.isMenuCollapse;
  },
};

export default {
  state,
  mutations,
  getters,
};
